import(/* webpackMode: "eager" */ "/home/quara/dev/presentgatan.se/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/home/quara/dev/presentgatan.se/src/app/components/pageHero/page-hero.module.scss");
;
import(/* webpackMode: "eager" */ "/home/quara/dev/presentgatan.se/src/app/components/Footer/footer.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/quara/dev/presentgatan.se/src/app/components/Underline/underline.js");
